import React from 'react';
import {bool, func} from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';

import {
  ModalSwimmy,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
} from '../../../components/ModalSwimmy';

import css from './SwimPlusConfirmationModal.css';
import {PrimaryButton} from '../../../components';

const SwimPlusConfirmationModal = props => {
  const {
    intl,
    onManageDisableScrolling,
    onModalClose,
    onSubmit,
    isModalOpen,
  } = props;
  const submitText = intl.formatMessage({id: 'Marketplace.continue'});

  return (
    <ModalSwimmy
      id="SwimPlusConfirmationModal"
      isOpen={isModalOpen}
      onClose={onModalClose}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <ModalOverlay/>
      <ModalContent className={css.modalContent}>
        {/*<ModalHeader className={css.modalHeader} heading={heading} />*/}
        <ModalCloseButton className={css.modalCloseButton}
                          handleClose={onModalClose}/>
        <ModalBody className={css.modalBody}>
          <h2>{intl.formatMessage({id: 'CartPage.SwimPlusConfirmationTitle'})}</h2>
          <p>{intl.formatMessage({id: 'CartPage.SwimPlusConfirmationDescription'})}</p>
          <PrimaryButton className={css.submitButton} onClick={onSubmit}>
            {submitText}
          </PrimaryButton>
        </ModalBody>
      </ModalContent>
    </ModalSwimmy>
  );
};

SwimPlusConfirmationModal.propTypes = {
  lisitngPriceDetailsModalOpen: bool,
  onLisitngPriceDetailsModalClose: func.isRequired,
  onManageDisableScrolling: func,
  intl: intlShape.isRequired,
};

export default injectIntl(SwimPlusConfirmationModal);
